import * as React from 'react';
import { connect } from 'react-redux';
import { goBack, push } from 'react-router-redux';
import {
  ButtonGroup,
  IconButton,
  Hero,
  Subtitle,
  Title,
  RouteWrapper,
} from '../../components';
import { removePayment } from '../../redux/actions/payments';

interface Props {
  match: any;
  handleRemovePayment: Function;
}

const Route = ({ match, handleRemovePayment }: Props) => (
  <RouteWrapper
    title="Remove Payment"
    requireAuth
    requirePermission="MANAGE_PAYMENTS"
  >
    <Hero className="is-danger is-fullheight has-text-centered">
      <Title large>Remove Payment?</Title>
      <Subtitle>
        Once this payment is removed, you will not be able to reference it
        anymore.
      </Subtitle>
      <ButtonGroup>
        <IconButton
          className="button is-danger is-large is-outlined is-inverted"
          handleClick={() => {
            handleRemovePayment(match.params.id);
          }}
          icon="trash"
          large
        >
          Remove Payment
        </IconButton>
        <IconButton
          className="button is-danger is-outlined is-large is-inverted"
          link={`/payments/${match.params.id}`}
          icon="undo"
          large
        >
          Cancel
        </IconButton>
      </ButtonGroup>
    </Hero>
  </RouteWrapper>
);

const mapDispatchToProps = (dispatch) => ({
  handleRemovePayment: (id) => {
    dispatch(removePayment(id)).then((response) => {
      if (!response.error) {
        dispatch(push('/payments'));
      }
    });
  },
});

export default connect(
  () => ({}),
  mapDispatchToProps,
)(Route);
